<template>
  <div id="background-container"></div>
</template>

<script>
export default {
  props: ["imgName"],
  mounted() {
    try {
      let img = null;

      if (this.imgName) {
        // Spezifisches Bild aus `assets/backgrounds/` laden
        img = require(`@/assets/img/backgrounds/${this.imgName}`);
      } else {
        // Dynamisch alle Bilder aus `assets/backgrounds/` laden
        const images = require.context(
          "@/assets/img/backgrounds",
          false,
          /\.jpg$/
        );

        // Die relativen Pfade aus `keys()` holen und zu gültigen URLs umwandeln
        const imagePaths = images.keys().map((key) => images(key));

        // Zufälliges Bild auswählen
        img = imagePaths[Math.floor(Math.random() * imagePaths.length)];
      }

      // Hintergrund setzen
      const backgroundContainer = document.getElementById(
        "background-container"
      );
      backgroundContainer.style.backgroundImage = `url('${img}')`;
    } catch (error) {
      console.info("Hintergrundbild konnte nicht geladen werden.", error);
    }
  },
};
</script>

<style scoped>
#background-container {
  position: fixed;
  top: 56px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
}
</style>
